import { ofType } from 'redux-observable';
import {
  catchError,
  map,
  switchMap,
  tap,
  withLatestFrom,
} from 'rxjs/operators';
import { EMPTY, from, of, concat, defer } from 'rxjs';
import { httpMethods, request } from '../../../../../services/http-service';
import { DELETE_TIMESHEET_TIPO } from '../../data.const';
import {
  retrieveTimesheetTipoListAction,
  setLoaders,
  setPopupInfo,
} from '../../data.action';

const deleteTimesheetTipoEpic = (action$: any, state$: any) =>
  action$.pipe(
    ofType(DELETE_TIMESHEET_TIPO),
    map(({ payload: { ids, ...rest } }: any) => ({
      body: {
        ids,
      },
      listBody: rest,
    })),
    withLatestFrom(state$),
    switchMap(([{ body, listBody }, _state]) => {
      return concat(
        of(setLoaders({ anagraficaLoader: true })),
        defer(() =>
          from(
            request({
              path: `timesheetTipo`,
              method: httpMethods.DELETE,
              body,
            })
          ).pipe(
            map((p: any) => {
              if (p?.status > 299) {
                throw new Error('Server error');
              }
              return p;
            }),
            switchMap(() => of(retrieveTimesheetTipoListAction(null))),
            catchError(err => {
              console.error(`[epic ${DELETE_TIMESHEET_TIPO}] error`, err);
              return EMPTY;
            })
          )
        ),
        of(setLoaders({ anagraficaLoader: false }))
      );
    })
  );

export default deleteTimesheetTipoEpic;
